import "./Footer.css";

export default function Footer() {
  const currentYear = new Date().getFullYear();
  return (
    <div className="footer">
      <p style={{margin:"0"}}>© {currentYear} | Powered by Businessbay</p>
      <div className="logo">
        <a href="https://www.facebook.com/people/Business-Bay/61551454974033/" target="blank"><img src="fb.svg" alt="Facebook" /></a>
        <a href="https://x.com/businessbay__" target="blank"><img src="twitter.svg" alt="Twitter" /></a>
        <a href="https://www.linkedin.com/company/business-bay/?viewAsMember=true" target="blank"><img src="linkedin.svg" alt="LinkedIn" /></a>
        <a href="https://www.instagram.com/businessbay_official/" target="blank"><img src="instagram.svg" alt="Instagram" /></a>
      </div>
    </div>
  );
}
